import { METHOD } from 'services/method'

export const API_EXPORT_POINT_MEMBER = {
    LIST: {
        api: '/v1/dashboard-admin/loyalty-program/olsera-export',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/loyalty-program/olsera-export',
        method: METHOD.POST,
    },
}
